export default "__VITE_ASSET__6a0a51a8__"